/*
 * TOPIAM Employee - Employee Identity and Access Management
 * Copyright © 2022-Present Jinan Yuanchuang Network Technology Co., Ltd. (support@topiam.cn)
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
export default {
  'pages.workbench.audit.desc':
    '审计日志记录了用户进行的关键操作，以对某次改变提供充分的溯源数据。',
  'pages.workbench.audit.user': '用户行为',
  'pages.workbench.audit.admin': '管理员行为',
  'pages.workbench.audit.columns.event_type': '事件类型',
  'pages.workbench.audit.columns.event_type.placeholder': '请选择事件类型',
  'pages.workbench.audit.columns.username': '操作者',
  'pages.workbench.audit.columns.user_id': '操作者 ID',
  'pages.workbench.audit.columns.user_type': '操作者类型',
  'pages.workbench.audit.columns.username.placeholder': '请输入用户名',
  'pages.workbench.audit.columns.geo_location': '客户端IP',
  'pages.workbench.audit.columns.platform': '操作系统',
  'pages.workbench.audit.columns.browser': '浏览器',
  'pages.workbench.audit.columns.event_time': '事件时间',
  'pages.workbench.audit.columns.event_status': '事件状态',
  'pages.workbench.audit.columns.device_type': '设备类型',
  'pages.workbench.audit.columns.operate_system': '操作系统',
  'pages.workbench.audit.columns.client_ip': '客户端IP',
  'pages.workbench.audit.columns.country': '国家',
  'pages.workbench.audit.columns.province': '省份',
  'pages.workbench.audit.columns.city': '城市',
  'pages.workbench.audit.columns.event_object': '操作对象',
  'pages.workbench.audit.columns.event_object.id': '对象 ID：',
  'pages.workbench.audit.columns.event_object.type': '对象类型：',
};
